import { render, staticRenderFns } from "./NeuraDashboard.vue?vue&type=template&id=ed4aef70&scoped=true&"
import script from "./NeuraDashboard.vue?vue&type=script&lang=js&"
export * from "./NeuraDashboard.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/repdashboard.css?vue&type=style&index=0&lang=css&"
import style1 from "./NeuraDashboard.vue?vue&type=style&index=1&id=ed4aef70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4aef70",
  null
  
)

export default component.exports